import { darken, IconButton, isWidthDown, makeStyles, withWidth } from '@material-ui/core';
import { Breakpoint } from '@material-ui/core/styles/createBreakpoints';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import { JobGridItem } from 'components';
import { Theme } from 'enum';
import { Job } from 'graphql/generated';
import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

type CarouselProps = {
    data: any[] | undefined;
    width: Breakpoint;
};

const useStyles = makeStyles((theme) => {
    return {
        arrow: {
            backgroundColor: '#fff',
            color: 'black',
            boxShadow: theme.palette.type === Theme.Light ? '0 0 10px rgba(0,0,0,.12)' : '0 0 10px rgba(0,0,0,.32)',
            width: 48,
            height: 48,
            '&:hover': {
                backgroundColor: theme.palette.type === Theme.Light ? darken('#eee', 0.03) : darken('#fff', 0.03),
            },
        },
    };
});

const Carousel: React.FC<CarouselProps> = ({ data, width }) => {
    const classes = useStyles();

    function ArrowRight(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
            >
                <IconButton className={classes.arrow} onClick={onClick}>
                    <KeyboardArrowRightIcon style={{ transform: 'translateX(1px)' }} />
                </IconButton>
            </div>
        );
    }

    function ArrowLeft(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{
                    ...style,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                <IconButton className={classes.arrow} onClick={onClick}>
                    <KeyboardArrowLeftIcon style={{ transform: 'translateX(-1px)' }} />
                </IconButton>
            </div>
        );
    }

    const carouselSettings = {
        className: 'center',
        centerMode: false,
        arrows: isWidthDown('sm', width) ? false : true,
        infinite: false,
        slidesToShow: isWidthDown('sm', width) ? 1.3 : 2.7,
        slidesToScroll: isWidthDown('sm', width) ? 1 : 2,
        draggable: isWidthDown('sm', width) ? true : false,
        speed: 250,
        nextArrow: <ArrowRight />,
        prevArrow: <ArrowLeft />,
    };

    return (
        <Slider {...carouselSettings}>
            {data?.map(({ node: job }) => (
                <JobGridItem key={job.id} job={job as Job} />
            ))}
        </Slider>
    );
};

export default withWidth()(Carousel);
